import React from 'react';
import { DocumentCard } from './DocumentCard';
import classes from './DocumentList.module.css';
import { IDocument } from '../../store/slices/documents';
import { IAttachment } from '../UI/SelectedSalesOrder/DigitalHealthProfileTab';
import Modal from '../UI/Modals/Modal';

type Props = {
  document: IDocument | IAttachment;
  isOpen: boolean;
  onClose: () => void;
};

const CommentDialog: React.FC<Props> = ({ document, isOpen, onClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      maxWidth={'80%'}
      width={'550px'}
      containerPadding={'20px'}
    >
      <DocumentCard
        document={document}
        mimeType={(document as IDocument).mime_type ?? document.name?.split('.').slice(-1)[0]}
        hideComment
        newDocumentModal
      />
      <div>
        <div className={classes.commentTitle}>Comment</div>
        <div className={classes.commentContainer}>{document.comment}</div>
      </div>
    </Modal>
  );
};

export { CommentDialog };
